import SceButton from "../../../../Common/CommonComponents/sceButton";
import ServiceAccountDetailsComponent from './serviceAccountDetailsComponent';
import overlayClasses from "./sceOverlayStyle.scss";
import classes from './emergencyAlertTurnOffPopup.scss';
import { getLocalizedStringstwo } from "../../../centralizedLocalizedStringtwo";
import EmergencyAlertErrCard from "../Common/emergencyAlertErrCard";
import FocusTrap from "focus-trap-react";
class EmergencyAlertTurnOffPopup extends React.Component {

    constructor(props) {
        super(props);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);        
        this.strings = getLocalizedStringstwo("EmergencyAlerts");
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
           }
        componentDidMount() {

            document.addEventListener('mousedown', this.handleClickOutside);
        }
        
        componentWillUnmount() {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
        
        setWrapperRef(node) {
            this.wrapperRef = node;
        }
        
        handleClickOutside(event) {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.handleClose();
            //  alert("clicked");
        
            }
        }     
    render() {
       let serviceAccountDetailsJSX;
         serviceAccountDetailsJSX = <ServiceAccountDetailsComponent selectedAccount={this.props.selectedAccount} />;
        return (
            <FocusTrap 
             focusTrapOptions={{
                allowOutsideClick: true,
            }}
            >
            <div>
                <div tabIndex="0" className={overlayClasses.sceOverlay}>
                    <div className={overlayClasses.sceOverlayContent}>
                        <div  ref={this.setWrapperRef} className={classes.sceDialogBox}>
                            <div className={classes.textAlignLeft}>
                                <div className='row'>
                                    <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.turnOffHeader} <button className={classes.iconClose}  onClick={this.props.handleClose} > <img  src={this.closeIcon} alt="close Icon" /></button></div>
                                    <div className="col-xs-12">
                                        <div className={classes.sceEaTurnOffWarningSec}>
                                            <p><i className={["fas fa-exclamation-triangle", classes.sceEaTurnOffWarningIcon].join(' ')} />&nbsp;{this.strings.warningHeading}&nbsp;<i className={["fas fa-exclamation-triangle ", classes.sceEaTurnOffWarningIcon].join(' ')} /></p>
                                            <p>{this.strings.warningText1}</p>
                                            <p className={classes.sceLongWarningSentence}>{this.strings.warningText2}</p>
                                            <p>{this.strings.warningText3}</p>
                                        </div>
                                    </div>
                                        {(this.props.isErrorCard) ? 
                                            <div>
                                                <EmergencyAlertErrCard
                                                    onFormhandler={this.props.emergencyAlertDeEnrollClick}
                                                />
                                            </div>
                                        : null}
                                </div>
                                <div className={classes.sceEaServiceAccountSection}>{serviceAccountDetailsJSX}</div>
                                <div className="text-align-center">
                                    <div className={classes.footerButton}>
                                        <div className={classes.turnOnBtn}>
                                            <SceButton
                                                id="EmergencyAlertsTurnOff"
                                                iconType="rightArrow"
                                                buttonType="primary"
                                                value={this.strings.turnOffBtn}
                                                onClick={this.props.emergencyAlertDeEnrollClick}
                                            />
                                        </div>
                                        <div className={classes.cancelBtn}>
                                            <SceButton
                                                id="turnOffEmergencyAlertCancel"
                                                iconType="cancel"
                                                buttonType="sceCancel"
                                                value={this.strings.cancelButton}
                                                onClick={this.props.handleClose}
                                            />
                                        </div>
                                    </div>                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </FocusTrap>
        );
    }
}
export default EmergencyAlertTurnOffPopup;